import { createAction } from '@reduxjs/toolkit';

const savePassengerFormValues = createAction(
  'ui/sealink/journey/savePassengerFormValues'
);

export { savePassengerFormValues };
